import getAllNotificationsStatus from "./getAllNotificationsStatus";
const NotificationsStatus = {
    getAllNotificationsStatus,
};

export default NotificationsStatus;